import React, { useState } from 'react';
import './styles.scss';

export interface ChildrenReturnType {
  menu: React.ReactElement;
  content: React.ReactElement;
}

export interface ChildrenArgsType {
  currentMenu: string;
  onMenuChange(menu: string): void;
}

interface Props {
  children(args: ChildrenArgsType): ChildrenReturnType;
  defaultMenu: string;
}

const ViewCampaignBaseSelection: React.FC<Props> = ({ children, defaultMenu }) => {
  const [currentMenu, setCurrentMenu] = useState(defaultMenu);

  const renderChildren = (args: ChildrenArgsType) => {
    const { menu, content } = children(args);
    return (
      <React.Fragment>
        <div>{menu}</div>
        <div>{content}</div>
      </React.Fragment>
    );
  };

  const handleMenuChange = (menu: string) => {
    setCurrentMenu(menu);
  };

  return (
    <div className="view-campaign-base-selection">
      <div className="ccbs-body">
        {renderChildren({
          currentMenu,
          onMenuChange: handleMenuChange
        })}
      </div>
    </div>
  );
};

export default ViewCampaignBaseSelection;
